import React, { useContext, useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { getLastPathParam } from "../CommonFun";
import { Link } from "react-router-dom";
import AautocompleteSearch from "../CustomizedHook/AautocompleteSearch";
import { AuthContext } from "../../context/AuthContext";
import { IoSearch } from "react-icons/io5";
import { GetApi } from "../../api/api-service";
import { API_Path } from "../../Const";
import AautocompleteSearchSlug from "../CustomizedHook/AautocompleteSearchSlug";

const type = [
    { name: "Agent", type: "agents" },
    { name: "Agencies", type: "find-agencies" },
];

export default function AgentFilter({ name, filterData, filterCallBack, data, handleReset, aData }) {
    const { languages, fatchLanguages, specialities, fatchSpecialities, cityData, fatchCity } = useContext(AuthContext);
    const [selectOption, setSelectOption] = useState({});
    const [agentName, setAgentName] = useState([]);

    useEffect(() => {
        if (name === "agent") {
            fatchLanguages();
            fatchSpecialities();
            fatchAgentName();
        } else if (name == "agencies") {
            fatchCity();
        }
    }, []);

    useEffect(() => {
        setSelectOption(filterData);
    }, [filterData]);

    useEffect(() => {
        var urlValue = getLastPathParam();
        if (urlValue != null && urlValue != undefined && urlValue != "") {
            const findData = type.find((item) => item.type === urlValue);
            if (findData) {
                setSelectOption({ ...selectOption, type: findData.name });
            }
        }
    }, []);
    const handleSearchChange = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        const searchData = { ...selectOption };
        searchData[name] = value;
        setSelectOption(searchData);
        filterCallBack(searchData);
    };
    const fatchAgentName = async () => {
        try {
            const res = await GetApi(API_Path.agentDetails + "/Name");
            if (res?.data?.success) {
                let data = res.data.data;
                const formattedNames = data.map((name) => ({ name: name.trim() }));
                setAgentName(formattedNames);
            }
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };

    return (
        <>
            <div className="filter-dropdown">
                <DropdownButton id="dropdown-item-button" title={selectOption.type}>
                    {type.map((name, i) => (
                        <Link to={`/${name.type}`} className="w-100" key={i}>
                            <Dropdown.Item
                                as="div"
                                className={`dropdown-content ${selectOption.type === name.name ? " active" : ""}`}
                                onClick={() => setSelectOption({ ...selectOption, type: name.name })}
                            >
                                {name.name}
                            </Dropdown.Item>
                        </Link>
                    ))}
                </DropdownButton>
            </div>
            <div className="custom-input">
                <IoSearch className="input-icon" />
                <input type="search" placeholder="Search" name="searchValue" value={filterData?.searchValue} onChange={handleSearchChange} maxLength={20} />
            </div>
            <AautocompleteSearchSlug
                data={filterData?.type == "Agent" ? agentName : aData}
                filterData={filterData}
                filterCallBack={filterCallBack}
                kName="name"
                plshdr="name"
                multiShow={true}
                handleReset={handleReset}
            />
            {filterData?.type == "Agent" ? (
                <AautocompleteSearchSlug data={languages} filterData={filterData} filterCallBack={filterCallBack} kName="name" plshdr="languages" multiShow={true} handleReset={handleReset} />
            ) : (
                <AautocompleteSearch data={cityData} filterData={filterData} filterCallBack={filterCallBack} kName="cityName" plshdr="city" multiShow={false} handleReset={handleReset} />
            )}
            {filterData?.type == "Agent" && (
                <AautocompleteSearch data={specialities} filterData={filterData} filterCallBack={filterCallBack} kName="name" plshdr="specialities" multiShow={false} handleReset={handleReset} />
            )}
        </>
    );
}
